import React, { Component } from "react";

class Help extends Component {
  constructor(props) {
    super(props);

    this.state = {
      info: ''
    };
  }

  checkNetType = () => {
    const info = navigator.connection;
    const re = {};
    for (let key in info) {
      if (typeof key !== 'function') {
        re[key] = info[key];
      }
    }
    this.setState({
      info: JSON.stringify(re, null, 2)
    });
  };

  componentDidMount() {
    if (navigator.connection) {
      navigator.connection.onchange = () => this.checkNetType();
      this.checkNetType();
    }
  }

  handleChange = () => {
    
  };

  render() {
    return (
      <textarea rows="20" style={{width: '100%'}} value={this.state.info} onChange={this.handleChange}></textarea>
    );
  }
}

export default Help;
